import { QrGeneratorTool } from '@/features/qr-generator'
import { useT } from '@/shared/i18n'
import { ToolHeading } from '@/shared/ui/ToolHeading'

export function QrGeneratorPage() {
  const t = useT()

  return (
    <div className="mx-auto max-w-6xl">
      <ToolHeading title={t.qr.hero.title} description={t.qr.hero.description} />

      <div className="mt-4 sm:mt-6">
        <QrGeneratorTool syncUrl />
      </div>

      <div className="mt-8 grid gap-5 lg:grid-cols-2">
        <section className="rounded-lg border bg-card p-5 shadow-sm">
          <h2 className="text-lg font-semibold tracking-normal">{t.qr.howToTitle}</h2>
          <ol className="mt-3 list-decimal space-y-2 pl-5 text-sm leading-6 text-muted-foreground">
            {t.schema.howTo.map((step) => (
              <li key={step}>{step}</li>
            ))}
          </ol>
        </section>

        <section className="rounded-lg border bg-card p-5 shadow-sm">
          <h2 className="text-lg font-semibold tracking-normal">{t.qr.faqTitle}</h2>
          <div className="mt-3 space-y-3">
            {t.schema.faq.map((item) => (
              <div key={item.question}>
                <h3 className="text-sm font-semibold">{item.question}</h3>
                <p className="mt-1 text-sm leading-6 text-muted-foreground">{item.answer}</p>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  )
}
